module.exports = __webpack_public_path__ + "img/parent-ma-image.6e2dcf08.png";